/** Brand tokens from jpbuana.com/dhaassets/frontend/landing/css/jpb-global.css */
export const JPB = {
  navy950: '#07172D',
  navy900: '#0B1F3A',
  navy800: '#102B4E',
  navy700: '#173B67',
  blue700: '#174F8A',
  blue600: '#2367A6',
  blue500: '#347FBE',
  blue400: '#65A2D2',
  white: '#FFFFFF',
  warmWhite: '#FCFBF8',
  ivory: '#F7F4ED',
  uiNeutral: '#F2F4F6',
  gold600: '#A9823A',
  gold500: '#C19A4B',
  gold400: '#D4B66A',
  goldSoft: '#E8D8AE',
  goldInk: '#8A6A2B',
  textPrimary: '#172333',
  textSecondary: '#536171',
  textMuted: '#6B7683',
  textOnDark: '#F7F8FA',
  borderSolid: '#E4E8EC',
  borderLight: 'rgba(15, 35, 60, 0.10)',
  chatGradient: 'linear-gradient(180deg, #FCFBF8 0%, #F7F4ED 42%, #F2F4F6 100%)',
  cardGradient: 'linear-gradient(135deg, #FFFFFF 0%, #FCFBF8 100%)',
  radius: '10px',
  radiusLg: '14px',
  shadow: '0 1px 2px rgba(16, 24, 32, 0.04), 0 8px 24px -12px rgba(16, 24, 32, 0.12)',
};

/** Tailwind class bundles aligned with jpbuana.com */
export const JPB_TW = {
  btn: 'flex items-center px-4 py-2 bg-jpb text-white rounded-jpb hover:bg-jpb-dark focus:outline-none focus:ring-2 focus:ring-jpb transition duration-200 ease-in-out transform hover:scale-105 text-sm font-medium',
  btnMobile: 'flex justify-center items-center px-4 py-2 bg-jpb text-white rounded-jpb hover:bg-jpb-dark focus:outline-none focus:ring-2 focus:ring-jpb transition duration-200 ease-in-out transform hover:scale-105 text-sm font-medium w-full',
  btnSm: 'px-4 py-2 bg-jpb text-white rounded-jpb hover:bg-jpb-dark',
  inputFocus: 'focus:outline-none focus:ring-2 focus:ring-jpb',
  price: 'text-jpb font-bold',
  productCard: 'bg-white rounded-jpb-lg overflow-hidden cursor-pointer border border-jpb/10 shadow-sm hover:shadow-md hover:border-jpb-light transition duration-200 ease-in-out hover:scale-[1.02]',
};
